export function useUrlPage(key = "page") {
  const route = useRoute();
  const router = useRouter();

  return computed<number>({
    get: () => {
      const raw = route.query[key];
      const n = typeof raw === "string" ? parseInt(raw, 10) : NaN;
      return Number.isFinite(n) && n > 1 ? n : 1;
    },
    set: (v) => {
      const currentRaw = route.query[key];
      const newRaw = v > 1 ? String(v) : undefined;
      if ((currentRaw ?? undefined) === newRaw) return;
      const query = { ...route.query };
      if (newRaw !== undefined) query[key] = newRaw;
      else delete query[key];
      router.push({ query });
    },
  });
}
